import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GeneratedClientManagerService } from '../generated-client-manager.service';
import {
  InstanceResponseDto,
  RegisterClient,
  RegisterInstanceDto,
  UpdateInstanceDto
} from '../simulation.generated.client';

@Injectable()
export class InstancesRegisterService extends GeneratedClientManagerService {
  private _client: RegisterClient;

  constructor() {
    super();
    this._client = new RegisterClient(this.httpClient, this.baseUrl);
  }

  getInstances(): Observable<InstanceResponseDto[]> {
    const context = this.buildHttpContext({
      avoid: true,
    });
    return this._client.getInstances(context); // of(INSTANCES);
  }

  getInstance(id: string): Observable<InstanceResponseDto> {
    const context = this.buildHttpContext();
    return this._client.getInstance(id, context);
  }

  unregisterInstance(id: string): Observable<InstanceResponseDto> {
    const context = this.buildHttpContext();
    return this._client.unregisterInstance(id, context);
  }

  // getInstances2(id: string): Observable<InstanceResponseDto[]> {
  //   const context = this.buildHttpContext();
  //   return this._client.getInstances2(id, context);
  // }

  registerInstance(registerInstanceDto: RegisterInstanceDto): Observable<InstanceResponseDto> {
    const context = this.buildHttpContext();
    return this._client.registerInstance(registerInstanceDto, context);
  }

  updateStatus(updateInstanceDto: UpdateInstanceDto): Observable<InstanceResponseDto> {
    const context = this.buildHttpContext();
    return this._client.updateStatus(updateInstanceDto, context);
  }
}
